import '../assets/css/Spinner.css';

const Spinner = () => {
  return (
    <>
      <div className="loadingio-spinner-spinner-ir885w8u5m"><div className="ldio-o7fpejxgu2e">
<div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div>
</div></div>
    </>
  )
}

export default Spinner
